export const strapiGetI18nSlug = (locale: string) => {
  switch (locale) {
    case 'en-US':
    case 'en':
      return 'i18n_slug_en'
    case 'nl-NL':
    case 'nl':
      return 'i18n_slug_nl'
    default:
      return 'i18n_slug_en'
  }
}
